import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LooksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"looks"}/>
}
